import React from "react";
import { LuMoon, LuSun } from "react-icons/lu";
import { useTheme } from "../theme/ThemeContext";

export default function ThemeToggle() {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? "Mudar para modo claro" : "Mudar para modo escuro";

  return (
    <button
      type="button"
      className="zuno-theme-toggle"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
    >
      {isDark ? <LuSun aria-hidden="true" /> : <LuMoon aria-hidden="true" />}
    </button>
  );
}
